import { render, staticRenderFns } from "./LaboralFunctionList.vue?vue&type=template&id=e907610e"
import script from "./LaboralFunctionList.vue?vue&type=script&lang=js"
export * from "./LaboralFunctionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports